module.exports = __webpack_public_path__ + "d664201f/img/chevron-down-icon.5542f65c.svg";